import React, { useEffect, useState, useRef } from 'react';

import Input from '../components/Input';
import Button from '../components/Button';
import Text from '../components/Text';
import Avatar from '../components/Avatar';
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

import { getCookie, setCookie, killCoockie, randomLetter } from '../assets/js/helper'

function Partie_lettre(props) {
    const navigate = useNavigate();

    const [lettre, setLettre] = useState(null);
    const [numero, setNumero] = useState(null);
    const [statuc, setStatuc] = useState('encours');
    const [avatar, setAvatar] = useState(null);
    const [pseudo, setPseudo] = useState(null);
    const [score, setScore] = useState(null);
    const [email, setEmail] = useState(null);
    // Recup des infos des cookies
    const wPlayer = JSON.parse(getCookie('w-player'));
    console.log('player', wPlayer.player);
    console.log('avatar', wPlayer.player.avatar);
    console.log('pseudo', wPlayer.player.pseudo);
    console.log('score', wPlayer.player.score);
    console.log('email', wPlayer.player.email);

    const form = useRef();

    useEffect(() => {
        setAvatar(wPlayer.player.avatar);
        setEmail(wPlayer.player.email);
        setPseudo(wPlayer.player.pseudo);
        setScore(wPlayer.player.score + ' pts');
        setLettre(randomLetter());
        setNumero(randomLetter(9, 'ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'));
    }, []);

    const handleSubmit = (event) => {
        event.preventDefault();
        console.log({
            lettre: lettre,
            numero: numero,
            statuc: statuc
        })
        axios.post(`http://localhost:5000/apiRouter/createpartie`, {
            lettre: lettre,
            numero: numero,
            statuc: statuc
        })
            .then(res => {
                console.log("res", res);
                console.log("res.data", res.data);
                if (res.data.status === "ok") {
                    // alert('resultat ok')
                    setCookie('w-partie-encours', JSON.stringify(res.data.partie), 356);
                    navigate("/partieblocs")
                }
                if (res.data.status === "ko") {
                    // setValidation(false);
                    // alert('compte inconnu')
                    alert('Oups une panne vous empeche de continuer. Veuillez recommencer plus tard')
                }

            })

            .catch(function (error) {
                // console.log('error', error.toJSON());
                alert('error ', error)

            });
        // navigate('/ReadWord', { replace: true })

    };

    return (
        <div className="w-home row w-fullscreen">
            <div className='col-lg-3 bg-blue w-half-left'>
                <Avatar
                    type="w-avatar-info"
                    nom={pseudo}
                    mail={email}
                    worder={score}
                    src={avatar}
                    classes="w-avatar-info"
                />
                <Link to="/home">
                    <Button text="Accueil" classes="w-btn-white" />
                </Link>
                <Link to="/partielettre">
                    <Button text="Nouvelle partie" classes="w-btn w-btn-blue" />
                </Link>
                <Link to="/scores">
                    <Button text="Voir les scores" classes="w-btn-white" />
                </Link>
                <Link to="/worders">
                    <Button text="Les WOrders (50)" classes="w-btn-white" />
                </Link>
                <Link to="/">
                    <Button text="Quitter" classes="w-text w-btn-gray" />
                </Link>
                <Link to="/aide">
                    <Text text="Besoin d'aide ?" classes="w-text-white-lg" />
                </Link>
            </div>
            <form ref={form} onSubmit={handleSubmit} className='col-lg-9 w-half-right'>
  
                <Text text={numero} classes="w-text-gray-m" />
                <Text text="Lettre choisie : " classes="w-text-blue-l" />
                <Text text={lettre} classes="w-text-blue-xxl" />
                <input value={lettre} name="lettre" className='w-hidden' />
                <input value={numero} name="numero" className='w-hidden' />

                <Button text="Go !" classes="w-btn-blue-lg" />

            </form>
        </div>
    );
}

export default Partie_lettre;